<!-- Loading state -->
<div *ngIf="isLoading" style="padding: 40px; text-align: center; color: #6b7280;">
  Loading order details...
</div>

<div class="main-wrapper" *ngIf="!isLoading && order">
  <div class="page-wrapper">
    <div class="content">

      <div class="order-view-content">

        <div class="order-title-row">
          <div>
            <h4 class="order-title">{{ order.orderNo }} &mdash; {{ order.customerName }}</h4>
            <div class="order-subtitle">
              {{ order.route }}
              <span class="dot">&middot;</span>
              <span class="badge order-type-badge" [ngClass]="order.orderType?.toLowerCase()">
                {{ order.orderType | titlecase }}
              </span>
            </div>
          </div>

          <div class="title-actions">
            <span class="badge status-badge" [ngClass]="statusBadgeClass()">{{ statusLabel() }}</span>
            <a href="javascript:void(0)" class="back-link" (click)="goBack()">Back</a>
          </div>
        </div>

        <!-- ══════════════════════════════════════
             SECTION 1: General Details
        ══════════════════════════════════════ -->
        <div class="card-section">
          <div class="section-header">
            <span class="step-badge">1</span>
            <h5>General Details</h5>
          </div>

          <div class="section-body">
            <div class="form-grid">

              <div class="form-field">
                <label>Order No.</label>
                <input type="text" class="form-control" [value]="order.orderNo" readonly />
              </div>

              <div class="form-field">
                <label>LR Number</label>
                <input
                  type="text"
                  class="form-control"
                  readonly
                  [ngClass]="{ 'editable': canEditLrNumber(), 'highlight-green': order.lrNumber }"
                  [readonly]="!canEditLrNumber()"
                  [(ngModel)]="order.lrNumber"
                  placeholder="--" />
              </div>

              <div class="form-field">
                <label>Customer</label>
                <input type="text" class="form-control" [value]="order.customerName" readonly />
              </div>

              <div class="form-field">
                <label>Order Type</label>
                <input type="text" class="form-control" [value]="order.orderType | titlecase" readonly />
              </div>

              <div class="form-field">
                <label>Vehicle Type</label>
                <input type="text" class="form-control" [value]="order.vehicleType | titlecase" readonly />
              </div>

              <div class="form-field">
                <label>Placement Date</label>
                <input type="text" class="form-control" [value]="order.vehicleRequiredAt" readonly />
              </div>

              <div class="form-field">
                <label>Status</label>
                <span class="badge status-badge" [ngClass]="statusBadgeClass()">{{ statusLabel() }}</span>
              </div>

              <div class="form-field">
                <label>Bidding Status</label>
                <input type="text" class="form-control" [value]="order.biddingStatus || '--'" readonly />
              </div>

              <div class="form-field">
                <label>Truck Count</label>
                <input type="text" class="form-control" [value]="order.numberOfVehicle" readonly />
              </div>
              
              <div class="form-field">
                <label>Assigned KAM</label>
                <input type="text" class="form-control" [value]="order.assignedKam" readonly />
                <!-- <ng-select
                  [ngClass]="{ 'disabled': !canEditGeneralDetails() }"
                  class="padding-8px"
                  [items]="kamList"
                  bindLabel="name"
                  [readonly]="true"
                  bindValue="id"
                  appendTo="body"
                  [disabled]="!canEditGeneralDetails()"
                  placeholder="Select KAM"
                  [(ngModel)]="order.assignedKam">
                </ng-select> -->
              </div>

              <div class="form-field">
                <label>Assigned Procurement Exec.</label>
                <input type="text" class="form-control" [value]="order.assignedProcExec" readonly />
                <!-- <ng-select
                  [ngClass]="{ 'disabled': !canEditProcExec() }"
                  class="padding-8px"
                  [items]="procurementExecList"
                  bindLabel="name"
                  [readonly]="true"
                  bindValue="id"
                  appendTo="body"
                  [disabled]="!canEditProcExec()"
                  [(ngModel)]="order.assignedProcExec"
                  placeholder="Select procurement executive">
                </ng-select> -->
              </div>

            </div>
          </div>

          <!-- <div class="section-footer" *ngIf="canEditGeneralDetails()">
            <button type="button" class="btn btn-purple" (click)="saveGeneralDetails()">Save</button>
          </div> -->
        </div>

        <!-- ══════════════════════════════════════
             SECTION 2: Pricing
             (Flattened — no contract/spot branching; role +
             order.isNullPrice drive what's visible, same as
             the React screen.)
        ══════════════════════════════════════ -->
        
        <div class="card-section" *ngIf="showPricingSection()">
          <div class="section-header">
            <span class="step-badge">2</span>
            <h5>{{ pricingSectionTitle() }}</h5>
          </div>

          <div class="section-body">

            <!-- Vendor role — no pricing visibility -->
            <div class="info-banner restricted-banner" *ngIf="hasRole('ROLE_VENDOR')">
              <b>Vendor View.</b> Pricing details are not visible to your role.
            </div>

            <ng-container *ngIf="notRole('ROLE_VENDOR')">

              <!-- Info banner (only shows once there's something actionable) -->
              <div class="info-banner" *ngIf="infoBannerText()">{{ infoBannerText() }}</div>

              <!-- No customer rate set (KAM only) -->
              <div class="warning-banner" *ngIf="showNullPriceBanner() && (order.status === 'CREATED' || order.status === 'PRICING_PENDING' || order.status === 'QUOTE_PENDING')">
                <div>
                  <b>🚫 No customer rate set</b><br />
                  <span style="font-weight:400;">
                    {{ hasProcQuote() ? 'Procurement quote received — set customer rate below.' : 'Get Procurement quote first.' }}
                  </span>
                </div>
              </div>

              <!-- Bidding completed acknowledgement (Procurement view) -->
              <div class="info-banner approval-banner-green" *ngIf="hasRole('ROLE_PROCUREMENT') && biddingCompleted()">
                ✓ Bidding completed — best bid price is shown below.
              </div>

              <!-- Head approval pending banner -->
              <div class="approval-banner" *ngIf="showApprovalRequiredBanner()">
                <b>Approval Required.</b> KAM submitted a rate below the procurement rate. Please review and enter the approved amount.
              </div>

              <div class="form-grid">

                <!-- Customer Rate — KAM or Proc Head. Post-Head-approval this
                     is still the number KAM confirms against (procHeadAmount
                     itself is never shown to KAM), so keep it visible right
                     up to ORDER_CONFIRMED, not just before HEAD_APPROVED. -->
                <div class="form-field" *ngIf="(isKAM() || isProcHeadRole()) && hasCustomerRate() && order.status !== 'ORDER_CONFIRMED'">
                  <label>Customer Rate (₹)</label>
                  <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.customerAmount)" readonly />
                </div>

                <!-- Procurement Rate (marked up) — KAM or Proc Head, null price only, not approved/confirmed -->
                <div class="form-field" *ngIf="order?.isNullPrice && order?.profitAdjustedProcAmount && order.status !== 'HEAD_APPROVED'">
                  <label>Adjusted Procurement Amount (₹)</label>
                  <input type="text" class="form-control highlight-yellow" [value]="formatCurrency(order.profitAdjustedProcAmount)" readonly />
                </div>

                <!-- Head Amount — Proc Head only. Intentionally NEVER shown to
                     KAM: KAM's whole view of the approved number is the
                     Customer Rate field above. -->
                <div class="form-field" *ngIf="isProcHeadRole() && hasHeadRate() && order.status !== 'ORDER_CONFIRMED'">
                  <label>Head Amount (₹)</label>
                  <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.procHeadAmount)" readonly />
                </div>

                <!-- Procurement (both Procurement and Proc Head) — marked-up customer rate -->
                <div class="form-field" *ngIf="isProcurementAny() && order.profitAdjustedCustomerAmount">
                  <label>Customer Rate (₹)</label>
                  <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.profitAdjustedCustomerAmount)" readonly />
                </div>

                <!-- Procurement — procurement amount -->
                <div class="form-field" *ngIf="isProcurementOnly() && order.procurementProvidedAmount">
                  <label>Procurement Amount (₹)</label>
                  <input type="text" class="form-control highlight-yellow" [value]="formatCurrency(order.procurementProvidedAmount)" readonly />
                </div>

                <!-- Best bid price, if bidding has produced one -->
                <div class="form-field" *ngIf="order.procurementPrice">
                  <label>Best Bid Price (₹)</label>
                  <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.procurementPrice)" readonly />
                </div>
                
                <div class="form-field">
                  <label>Status</label>
                  <span class="badge status-badge" [ngClass]="statusBadgeClass()">{{ statusLabel() }}</span>
                </div>
                
                <div class="form-field" *ngIf="order.biddingEnable === 1 && hasRole('ROLE_PROCUREMENT')">
                  <label>Bidding</label>
                  <span class="badge badge-yellow">Enabled</span>
                </div>
                
                <div class="form-field" *ngIf="hasRole('ROLE_PROCUREMENT_HEAD') && order.vendorName">
                  <label>Active Vendor Name</label>
                  <input type="text" class="form-control highlight-yellow" [value]="order.vendorName" readonly />
                </div>

              </div>

              <!-- Margin banner — Proc Head only, Customer Rate vs Procurement Amount -->
              <ng-container *ngIf="pricingCardMargin() as margin">
                <div class="margin-card" [ngClass]="{ 'margin-profit': margin.isPositive, 'margin-loss': !margin.isPositive }">
                  <div class="margin-header">MARGIN</div>
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <span class="margin-value mr-10">{{ formatCurrency(margin.amt) }}</span>
                      <span class="margin-percent">({{ margin.isPositive ? '+' : '-' }}{{ absVal(margin.pct) }}%)</span>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- ═══ KAM ACTION PANEL — QUOTE_SHARED or HEAD_APPROVED ═══
                   This is the "confirm pricing, or enter a lower amount that
                   routes to Head" view. Given its own card so it's clearly
                   visible instead of blending into the read-only fields above.

                   Post-Head-approval (HEAD_APPROVED): the floor KAM cannot
                   go below is the visible Customer Rate field above
                   (order.customerAmount) — NOT order.procHeadAmount, which
                   KAM never sees. The component's belowHeadFloor()/
                   postHeadFloor() logic is written to match this. -->
              <ng-container *ngIf="showKAMActions()">
                <div class="action-card" [ngClass]="showFinalBidRatePanel() ? 'action-card-amber' : 'action-card-green'">

                  <div class="action-card-header">
                    {{ isPostHeadApproval() ? 'Confirm at the approved rate, or increase it' : 'Confirm at this rate, or adjust it' }}
                  </div>

                  <div class="form-grid" *ngIf="showFinalBidRatePanel()">
                    <div class="form-field">
                      <label>Final Rate (₹) <span class="required">*</span></label>
                      <input
                        type="text"
                        appIndianNumberFormat
                        class="form-control editable"
                        placeholder="Enter customer rate"
                        [(ngModel)]="finalBdRateInput" />

                      <!-- Hard floor: post-Head-approval OR known-price Spot pre-approval -->
                      <small class="field-hint" *ngIf="hasRateFloor() && finalBdRateInput && order.customerAmount">
                        <span *ngIf="belowHeadFloor()" class="hint-warn">
                          ⚠ Cannot be less than the Customer Rate ({{ formatCurrency(order.customerAmount) }})
                        </span>
                        <span *ngIf="!belowHeadFloor()" class="hint-ok">
                          ✓ Will be confirmed
                        </span>
                      </small>

                      <!-- Pre-Head, null-price routing hint (procurement threshold, not a hard floor) -->
                      <small class="field-hint" *ngIf="!hasRateFloor() && finalBdRateInput && order.profitAdjustedProcAmount">
                        <span *ngIf="finalBdRateInput < order.profitAdjustedProcAmount" class="hint-warn">
                          ⚠ Below procurement rate — will go to Head for approval
                        </span>
                        <span *ngIf="finalBdRateInput >= order.profitAdjustedProcAmount" class="hint-ok">
                          ✓ Will be confirmed directly
                        </span>
                      </small>
                    </div>
                  </div>

                  <div class="action-card-footer">
                    <button
                      type="button"
                      *ngIf="isOrderCreator && showKAMActions()"
                      class="btn btn-green"
                      [disabled]="actionLoading || (showFinalBidRatePanel() && !finalBdRateInput) || belowHeadFloor()"
                      (click)="confirmKAMOrder()">
                      {{ confirmButtonLabel() }}
                    </button>
                    <button type="button" class="btn btn-outline-red" [disabled]="actionLoading" (click)="rejectOrder()">Reject</button>
                  </div>
                </div>
              </ng-container>

              <!-- Order confirmed banner -->
              <div class="info-banner" style="margin-top: 12px;" *ngIf="order.status === 'ORDER_CONFIRMED'">
                ✓ Order confirmed
              </div>

              <!-- ═══ PROC HEAD APPROVAL PANEL — HEAD_PENDING only ═══ -->
              <ng-container *ngIf="showHeadPanel()">
                <div class="action-card action-card-amber">
                  <div class="action-card-header">Review &amp; approve</div>

                  <div class="form-grid">
                    <div class="form-field">
                      <label>Final Procurement Amount (₹) <span class="required">*</span></label>
                      <input
                        type="text"
                        appIndianNumberFormat 
                        class="form-control editable"
                        placeholder="Enter approved amount"
                        [(ngModel)]="procHeadAmountInput" />
                      <small class="field-hint" *ngIf="headLiveMargin() as m">
                        <span [ngClass]="m.isPositive ? 'hint-ok' : 'hint-warn'">
                          Margin on Customer Rate: {{ formatCurrency(m.amt) }} ({{ m.isPositive ? '+' : '-' }}{{ absVal(m.pct) }}%)
                        </span>
                      </small>
                    </div>

                    <div class="form-field">
                      <label>Assign Vendor <span class="required">*</span></label>
                      <ng-select
                        [items]="assignVendorList"
                        bindLabel="vendorName"
                        bindValue="id"
                        [multiple]="false"
                        [searchable]="true"
                        appendTo="body"
                        placeholder="Search vendor..."
                        [loading]="isLoadingVendors"
                        [(ngModel)]="selectedVendorId"
                        (search)="onVendorSearch($event)"
                        (scrollToEnd)="loadMoreVendors()">
                        <ng-template ng-option-tmp let-item="item">
                          <div>
                            <div style="font-weight: 500; font-size: 0.9rem;">{{ item.vendorName }}</div>
                            <div style="font-size: 0.78rem; color: #888;">{{ item.email }}</div>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>

                  <div class="action-card-footer">
                    <button type="button" class="btn btn-outline-red" [disabled]="actionLoading" (click)="openHeadRejectModal()">Reject</button>
                    <button
                      type="button"
                      class="btn btn-green"
                      [disabled]="actionLoading || !procHeadAmountInput || !selectedVendorId"
                      (click)="submitHeadApproval()">
                      {{ actionLoading ? 'Approving...' : '✓ Approve' }}
                    </button>
                  </div>
                </div>
              </ng-container>

              <!-- Head already approved, waiting on KAM -->
              <div class="info-banner" style="margin-top: 16px;" *ngIf="isProcHeadRole() && order.status === 'HEAD_APPROVED'">
                ✓ You have approved this order with amount {{ formatCurrency(order.procHeadAmount) }}. Waiting for KAM confirmation.
              </div>

            </ng-container>

          </div>
        </div>

        <!-- Bottom bar -->
        <div class="bottom-bar">
          <div class="d-flex gap-2">
            <button *ngIf="canShowSubmitRateButton() && isOrderCreator && showKAMActions()" class="btn btn-primary" (click)="openSubmitRate(order)">Submit Rate</button>
            <button  *ngIf="(order.status === 'ORDER_CONFIRMED')" (click)="startTrip(order)" class="btn btn-primary">
              <span *ngIf="checkTripStatus(order,'PENDING')">Create</span> Trip <span *ngIf="!checkTripStatus(order,'PENDING')">Detail</span>
            </button>
            <button type="button" class="btn btn-outline" (click)="goBack()">Back</button>
          </div>
          <span class="badge status-badge" [ngClass]="statusBadgeClass()">{{ statusLabel() }}</span>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- ===========================
        REJECT POPUP
=========================== -->
<p-dialog
    [(visible)]="showRejectModal"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '30vw' }">

    <ng-template pTemplate="header">
        <div style="font-weight:600;font-size:18px">
            Confirm Rejection
        </div>
    </ng-template>

    <div>
        <p style="margin-bottom:15px;">
            Are you sure you want to reject this order?
        </p>

        <label>
            Remarks <span style="color:red">*</span>
        </label>

        <textarea
            rows="4"
            class="form-control"
            placeholder="Enter rejection remarks"
            [(ngModel)]="rejectRemark">
        </textarea>
    </div>

    <ng-template pTemplate="footer">
        <button
            class="btn btn-secondary"
            (click)="closeRejectModal()"
            [disabled]="rejectLoading">
            No
        </button>

        <button
            class="btn btn-primary"
            (click)="confirmReject()"
            [disabled]="rejectLoading || !rejectRemark.trim()">
            {{ rejectLoading ? 'Rejecting...' : 'Yes, Reject' }}
        </button>
    </ng-template>

</p-dialog>

<!-- ═══════════════════════════════════════════════
     SUBMIT RATE (Procurement)
════════════════════════════════════════════════ -->
<p-dialog
  [(visible)]="showSubmitRateDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '30vw' }"
  styleClass="submit-rate-dialog"
  (onHide)="closeSubmitRateDialog()">

  <ng-template pTemplate="header">
    <div>
      <div style="font-weight: 600; font-size: 1rem;">Submit rate</div>
      <div style="font-size: 0.8rem; color: #888; margin-top: 2px;">{{ currentOrderForRate?.orderNumber }}</div>
    </div>
  </ng-template>

  <div *ngIf="submitRateStep === 'confirm'" class="confirm-step">
    <div class="radar-icon">
       <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.001 512.001" xml:space="preserve" width="50" height="50" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect x="330.25" y="129.857" style="fill:#FFE6B8;" width="121.095" height="176.824"></rect> <g> <path style="fill:#D35B38;" d="M454.327,93.624H327.269c-10.006,0-18.118,8.111-18.118,18.118l0,0 c0,10.006,8.111,18.118,18.118,18.118h127.058c10.006,0,18.118-8.111,18.118-18.118l0,0 C472.444,101.736,464.333,93.624,454.327,93.624z"></path> <path style="fill:#D35B38;" d="M454.327,306.685H327.269c-10.006,0-18.118,7.883-18.118,17.889l0,0 c0,10.006,8.111,18.118,18.118,18.118h127.058c10.006,0,18.118-8.111,18.118-18.118l0,0 C472.444,314.568,464.333,306.685,454.327,306.685z"></path> </g> <path style="fill:#FFAD61;" d="M465.972,382.37H315.624c-19.787,0-35.829,16.041-35.829,35.829l0,0c0,0.099,0.08,0.178,0.178,0.178 h221.65c0.099,0,0.178-0.08,0.178-0.178l0,0C501.801,398.411,485.76,382.37,465.972,382.37z"></path> <rect x="210.991" y="201.873" style="fill:#FFE6B8;" width="119.259" height="32.801"></rect> <path style="fill:#D35B38;" d="M210.991,243.845H35.772c-14.124,0-25.572-11.449-25.572-25.571l0,0 c0-14.123,11.449-25.572,25.572-25.572h175.219V243.845z"></path> <g> <path style="fill:#4D3D36;" d="M465.972,372.17H315.624c-25.38,0-46.028,20.648-46.028,46.028c0,5.722,4.655,10.378,10.378,10.378 h221.65c5.722,0,10.378-4.655,10.378-10.378C512,392.819,491.352,372.17,465.972,372.17z M292.034,408.178 c3.909-9.167,13.011-15.609,23.59-15.609h150.349c10.579,0,19.68,6.441,23.589,15.609H292.034z"></path> <path style="fill:#4D3D36;" d="M320.051,244.871v52.543c-12.129,3.174-21.1,14.146-21.1,27.16 c0,15.614,12.703,28.317,28.317,28.317h127.058c15.615,0,28.318-12.703,28.318-28.317c0-13.014-8.971-23.986-21.1-27.16v-158.29 c12.129-3.199,21.1-14.262,21.1-27.382c0-15.615-12.703-28.318-28.318-28.318H327.269c-15.614,0-28.317,12.703-28.317,28.318 c0,13.12,8.971,24.182,21.1,27.382v52.551h-98.913c-0.515-5.151-4.861-9.173-10.147-9.173H35.772 C16.046,182.503,0,198.549,0,218.274s16.046,35.771,35.772,35.771h175.219c5.286,0,9.633-4.023,10.147-9.173H320.051z M340.449,140.06h100.696v156.426H340.449V140.06z M454.327,316.885c4.441,0,7.92,3.378,7.92,7.69c0,4.366-3.552,7.919-7.92,7.919 H327.269c-4.366,0-7.919-3.551-7.919-7.919c0-4.313,3.479-7.69,7.919-7.69H454.327z M327.269,119.662 c-4.366,0-7.919-3.552-7.919-7.92s3.552-7.92,7.919-7.92h127.058c4.366,0,7.92,3.552,7.92,7.92s-3.552,7.92-7.92,7.92H327.269z M320.051,224.473H221.19v-12.398h98.861V224.473z M20.398,218.274c0-8.477,6.897-15.372,15.373-15.372h165.02v30.745H35.772 C27.295,233.646,20.398,226.749,20.398,218.274z"></path> <path style="fill:#4D3D36;" d="M421.227,286.598c5.633,0,10.199-4.567,10.199-10.199v-60.175c0-5.632-4.566-10.199-10.199-10.199 s-10.199,4.567-10.199,10.199v60.175C411.028,282.031,415.594,286.598,421.227,286.598z"></path> <path style="fill:#4D3D36;" d="M421.227,197.865c5.633,0,10.199-4.567,10.199-10.199v-3.06c0-5.632-4.566-10.199-10.199-10.199 s-10.199,4.567-10.199,10.199v3.06C411.028,193.298,415.594,197.865,421.227,197.865z"></path> </g> </g></svg>
    </div>
    <h5 class="confirm-title">Initiate vendor bidding?</h5>
    <p class="confirm-subtitle">
      Would you like to invite vendors to bid on this order before submitting your rate?
    </p>
    <button type="button" class="btn btn-primary btn-block" (click)="onYesInvite()">
      Invite vendors
    </button>
    <button type="button" class="btn btn-cancel btn-block mt-2" (click)="onNoJustSubmit()">
      Submit rate
    </button>
  </div>

  <!-- ── Rate + Vendor form ── -->
  <div *ngIf="submitRateStep === 'form'" [formGroup]="rateForm">

    <div class="ceiling-banner" *ngIf="order?.profitAdjustedCustomerAmount">
      <span>Ceiling rate</span>
      <b>{{ formatCurrency(order?.profitAdjustedCustomerAmount) }}</b>
    </div>

    <!-- Rate -->
    <div class="mb-3">
      <label class="form-label">Your rate (₹) <span style="color:red">*</span></label>
      <input
        type="text"
        appIndianNumberFormat 
        class="form-control"
        placeholder="Enter amount"
        formControlName="rate" />
      <small class="text-danger" *ngIf="isRateInvalid('rate')">Rate is required</small>
    </div>

    <!-- Vendors -->
    <div class="mb-3">
      <label class="form-label">Select vendors <span style="color:red">*</span></label>

      <!-- Multiple when inviteVendors = true -->
      <ng-select
        *ngIf="inviteVendors"
        [items]="vendorList"
        bindLabel="vendorName"
        bindValue="id"
        [multiple]="true"
        [closeOnSelect]="false"
        appendTo="body"
        placeholder="Search vendors..."
        formControlName="vendors">

        <!-- Select All header -->
        <ng-template ng-header-tmp>
            <div style="padding: 8px 12px; border-bottom: 1px solid #eee; display: flex; align-items: center; gap: 8px; cursor: pointer;"
            (click)="toggleSelectAll()">
            <input
                type="checkbox"
                [checked]="isAllSelected()"
                [indeterminate]="isSomeSelected()"
                style="width: 15px; height: 15px; cursor: pointer;"
                (click)="$event.stopPropagation()" />
            <span style="font-size: 0.88rem; font-weight: 500; color: #374151;">Select all</span>
            </div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
            <div>
            <div style="font-weight: 500; font-size: 0.9rem;">{{ item.vendorName }}</div>
            <div style="font-size: 0.78rem; color: #888;">{{ item.email }}</div>
            </div>
        </ng-template>
        </ng-select>

      <!-- Single when inviteVendors = false -->
      <ng-select
        *ngIf="!inviteVendors"
        [items]="vendorList"
        bindLabel="vendorName"
        bindValue="id"
        [multiple]="false"
        appendTo="body"
        placeholder="Search vendors..."
        formControlName="vendors">
        <ng-template ng-option-tmp let-item="item">
          <div>
            <div style="font-weight: 500; font-size: 0.9rem; display:flex; align-items:center; gap:6px;">
              {{ item.vendorName }}
              <span *ngIf="alreadyInvitedVendorIds.includes(item.id)"
                    class="badge badge-grey" style="font-size:0.65rem;">Already sent</span>
            </div>
            <div style="font-size: 0.78rem; color: #888;">{{ item.email }}</div>
          </div>
        </ng-template>
      </ng-select>
      <small class="text-danger" *ngIf="isRateInvalid('vendors')">Please select at least one vendor</small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <ng-container *ngIf="submitRateStep === 'confirm'"></ng-container>
    <div *ngIf="submitRateStep === 'form'" class="d-flex justify-content-between w-100">
      <button type="button" class="btn btn-cancel" (click)="onRateBack()">
        ‹ Back
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="rateForm.invalid"
        (click)="onSubmitRate()">
        <span *ngIf="inviteVendors">Send &amp; initiate bidding</span>
        <span *ngIf="!inviteVendors">Submit rate</span>
      </button>
    </div>
  </ng-template>
</p-dialog>


<!-- ═══════════════════════════════════════════════
     HEAD REJECT (with remarks)
════════════════════════════════════════════════ -->
<p-dialog
  [(visible)]="showHeadRejectModal"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '28vw' }"
  styleClass="reject-remark-dialog"
  (onHide)="closeHeadRejectModal()">

  <ng-template pTemplate="header">
    <div>
      <div style="font-weight: 600; font-size: 1rem;">Reject Order</div>
      <div style="font-size: 0.8rem; color: #888; margin-top: 2px;">Please provide a reason for rejection</div>
    </div>
  </ng-template>

  <div class="mb-3">
    <label class="form-label">Remarks <span style="color:red">*</span></label>
    <textarea
      class="form-control"
      rows="4"
      placeholder="Enter rejection reason…"
      [(ngModel)]="headRejectRemark"></textarea>
    <small class="text-muted">{{ (headRejectRemark?.trim()?.length) || 0 }} characters</small>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex justify-content-between w-100">
      <button type="button" class="btn btn-cancel" (click)="closeHeadRejectModal()" [disabled]="rejectingHead">Cancel</button>
      <button
        type="button"
        class="btn btn-outline-red-solid"
        [disabled]="!headRejectRemark?.trim() || rejectingHead"
        (click)="confirmHeadReject()">
        {{ rejectingHead ? 'Rejecting...' : 'Reject Order' }}
      </button>
    </div>
  </ng-template>
</p-dialog>